'use client';

import { HpMarketingAd, type HpMarketingAdProps } from '@pickleballinc/ui/components/advertisements/hp-marketing/hp-marketing-ad';

import { renderHpMarketingCardV2 } from './hp-marketing-card-v2';

export interface HpMarketingAdWithCardsProps extends Omit<HpMarketingAdProps, 'renderCard'> {
	/**
	 * `true` renders listing (card) ads with the v2 module cards; `false` (default) keeps the rotator's
	 * built-in v1 cards. A boolean rather than the renderer itself — see below.
	 */
	useV2Cards?: boolean;
}

/**
 * Client-side binding between the HP marketing rotator and the v2 module cards.
 *
 * `HpMarketingAd` takes a `renderCard` function so that `@pickleballinc/ui` never has to import the v2
 * cards from `@pickleballinc/features` (which already depends on `ui`, so that import would close a
 * cycle). But a function prop cannot cross the server/client boundary: App Router defaults to server
 * components, and passing `renderCard` from one produces
 * "Functions cannot be passed directly to Client Components".
 *
 * This wrapper carries the `'use client'` directive, so the renderer is created inside the client
 * bundle and only a serializable boolean crosses the boundary. Call sites can therefore be server or
 * client components without caring which they are.
 *
 * Prefer this over reaching for `HpMarketingAd` + `renderCard` directly at a call site.
 */
export function HpMarketingAdWithCards({ useV2Cards = false, ...props }: HpMarketingAdWithCardsProps) {
	return <HpMarketingAd {...props} renderCard={useV2Cards ? renderHpMarketingCardV2 : undefined} />;
}
